export default () => {
  let scrl = window.scrollY;
  let navbar = document.getElementsByClassName("navbar")[0];
  if (scrl >= window.innerHeight - 100) {
    navbar.classList.remove("navbar-active");
    navbar.classList.add("navbar-sticky");
    document.getElementsByClassName("navbar-sticky")[0].style.visibility =
      "visible";
  } else {
    navbar.classList.add("navbar-active");
    navbar.classList.remove("navbar-sticky");
    let stickyNavbar = document.getElementsByClassName("navbar-sticky")[0];
    if (stickyNavbar) stickyNavbar.style.visibility = "hidden";
  }
  if (
    5 * scrl >= window.innerHeight / 2 &&
    scrl <= 3 * window.innerHeight - 100
  ) {
    let items_ = Array.from(document.getElementsByClassName("skill-item"));

    items_.forEach((e) => {
      setTimeout(() => {
        e.style.opacity = "1";
        e.style.transform = `translateX(0)`;
      }, Math.floor(Math.random() * 2000));
    });
  } else {
    let items_ = Array.from(document.getElementsByClassName("skill-item"));
    items_.forEach((e) => {
      e.style.opacity = "0";
      e.style.transform = `translateX(-25px)`;
    });
  }
};
